import type { ComponentProps } from "react";
import { motion } from "motion/react";
import type { VariantProps } from "tailwind-variants";
import { tv } from "tailwind-variants";

const styles = tv({
  base: "fixed size-8/12 rounded-full bg-radial blur-3xl",
  variants: {
    theme: {
      dark: "from-primary-600/20 to-primary-600/20",
      light: "from-primary-100/30 to-primary-100/30",
    },
  },
});

const shapeVariants = {
  left: {
    translateY: [0, 400, 0],
  },
  right: {
    translateY: [0, -400, 0],
  },
};

const AnimatedShape = ({
  position,
  ...props
}: ComponentProps<typeof motion.div> & { position: "left" | "right" }) => {
  return (
    <motion.div
      variants={shapeVariants}
      animate={position}
      transition={{
        duration: 13,
        repeat: Infinity,
        ease: "easeInOut",
        repeatType: "loop",
      }}
      {...props}
    />
  );
};

export const AnimatedBackground = ({ theme }: VariantProps<typeof styles>) => {
  return (
    <>
      <AnimatedShape
        position="left"
        className={styles({ theme, className: "top-0 -left-20" })}
      />
      <AnimatedShape
        position="right"
        className={styles({ theme, className: "-right-20 bottom-0" })}
      />
    </>
  );
};
